// export const serverUrl = "http://localhost:3001/posts/"
export const serverUrl = "https://posts-app-server.herokuapp.com/posts/";

export const defaultValues = {
  title: "",
  content: "",
  author: "Anonymous"
};
